{
    "TermsAndConditions_Title": "Termes et conditions",
    "TermsAndConditions_Subtitle": "Les conditions d'utilisation de l'application sont présentées ci-dessous. Veuillez les accepter en cochant la case « J'accepte les conditions d'utilisation » et en cliquant sur le bouton « Accepter ».",
    "TermsAndConditions_Subtitle_NoAccept": "Nos conditions générales de service sont présentées ci-dessous.",
    "TermsAndConditions_AcceptText": "J'accepte les termes et conditions",
    "TermsAndConditions_AcceptButton": "Accepter",
    "TermsAndConditions_CloseButton": "Fermer",
    "NAME": "TermsAndConditions"
}